import { utils, BigNumber } from 'ethers';
export const { formatUnits, parseUnits } = utils;

export const fromBNDec = formatUnits;
export const toBNDec = parseUnits;
export const toBN = BigNumber.from;
export const fromBN = (n: any) => formatUnits(n, 1);
